import { SmartFaqLine } from 'Components/lines/smart-faq-line/SmartFaqLine';
export default SmartFaqLine;
